/**
 * @module services/service-record
 * @description Servicio HTTP para el registro unificado de transacciones prestacionales
 */
import api from "./api";

export default {
  /** @param {Object} params - searchInput, origin, billingMonth, billingYear, offset, limit */
  get: (params) => api.get("/service-records", { params }).then((r) => r.data),
  /** @param {string} id */
  getById: (id) => api.get(`/service-records/${id}`).then((r) => r.data),
  /**
   * @description UC-REG-199 — Timeline reconstruido de una TRX.
   * @param {string} id
   * @returns {Promise<{events: Array}>}
   */
  getHistory: (id) =>
    api.get(`/service-records/${id}/history`).then((r) => r.data),
  /**
   * @description UC-REG-217 — Resumen agregado por prestador del período.
   * @param {Object} params - { year, month }
   * @returns {Promise<{rows: Array, totals: Object}>}
   */
  summaryByProvider: (params) =>
    api
      .get("/service-records/summary-by-provider", { params })
      .then((r) => r.data),
};
